import { BALANCE } from '../config/balance';
import type { EnemyKind } from '../core/types';
import {
  MIX_KINDS, mixWeights, sampleCurve, tableForMode,
} from './waves';
import type { Engine } from './engine';

/** 波次表导演：连续刷怪（混合权重）+ 锚定爆发 / Boss。全服同题。 */
export class WaveDirector {
  private timer: number;
  private burstIndex = 0;
  private readonly table: ReturnType<typeof tableForMode>;

  constructor(mode: Parameters<typeof tableForMode>[0]) {
    this.table = tableForMode(mode);
    this.timer = this.table.intervalCurve[0][1];
  }

  tick(engine: Engine, dt: number): void {
    this.timer -= dt;
    if (this.timer <= 0) {
      this.timer = Math.max(0.1, sampleCurve(this.table.intervalCurve, engine.time));
      this.spawnContinuous(engine);
    }
    while (
      this.burstIndex < this.table.bursts.length &&
      this.table.bursts[this.burstIndex].t <= engine.time
    ) {
      const b = this.table.bursts[this.burstIndex];
      if (b.boss) engine.spawnBoss(b.boss);
      this.spawnBurst(engine, b.v);
      this.burstIndex++;
    }
  }

  private spawnContinuous(engine: Engine): void {
    const weights = mixWeights(this.table, engine.time);
    const kind = engine.streams.world.weighted([...MIX_KINDS], weights) as EnemyKind;
    for (let k = 0; k < Math.round(engine.variant.spawnCountMul); k++) {
      const pos = this.ringPos(engine);
      engine.spawnEnemy(kind, pos.x, pos.y);
    }
  }

  private spawnBurst(engine: Engine, v: readonly number[]): void {
    for (let i = 0; i < MIX_KINDS.length; i++) {
      const n = Math.round((v[i] ?? 0) * engine.variant.spawnCountMul);
      const kind = MIX_KINDS[i] as EnemyKind;
      for (let k = 0; k < n; k++) {
        const pos = this.ringPos(engine);
        engine.spawnEnemy(kind, pos.x, pos.y);
      }
    }
  }

  private ringPos(engine: Engine): { x: number; y: number } {
    const a = engine.streams.world.range(0, Math.PI * 2);
    const r = engine.streams.world.range(BALANCE.spawn.ringMin, BALANCE.spawn.ringMax);
    return {
      x: engine.player.x + Math.cos(a) * r,
      y: engine.player.y + Math.sin(a) * r,
    };
  }
}
